import { client } from '../utils/fetch';
import { CaptureLogResponse, CaptureLogEntry } from '../types/CaptureLog';

export const getCaptureData = async (): Promise<CaptureLogEntry[]> => {
  const headers = {
    'Content-Type': 'application/json;charset=UTF-8',
  };

  try {
    const response = await client.get<CaptureLogResponse>('logs/capture', headers);
    // Return only the logs array, ignore the access_token
    return response.logs;
  } catch (error) {
    console.error("Error fetching capture data:", error);
    throw error;
  }
}; 